const reportingDashboardConstants = {
  GET_ALL_REPORTS_START: "GET_ALL_REPORTS_START",
  GET_ALL_REPORTS_SUCCESS: "GET_ALL_REPORTS_SUCCESS",
  GET_ALL_REPORTS_FAILED: "GET_ALL_REPORTS_FAILED",
  ADD_REPORT_START: "ADD_REPORT_START",
  ADD_REPORT_END: "ADD_REPORT_END",
  ADD_REPORT_FAILED: "ADD_REPORT_FAILED",
  VIEW_REPORT_START: "VIEW_REPORT_START",
  VIEW_REPORT_SUCCESS: "VIEW_REPORT_SUCCESS",
  VIEW_REPORT_FAILED: "VIEW_REPORT_FAILED",
  EDIT_REPORT_START: "EDIT_REPORT_START",
  EDIT_REPORT_END: "EDIT_REPORT_END",
  EDIT_REPORT_FAILED: "EDIT_REPORT_FAILED",
  EDIT_REPORT_SUCCESS: "EDIT_REPORT_SUCCESS",
  FILTER_REPORT_START: "FILTER_REPORT_START",
  FILTER_REPORT_SUCCESS: "FILTER_REPORT_SUCCESS",
  FILTER_REPORT_FAILED: "FILTER_REPORT_FAILED",
  GET_ALL_UPDATED_REPORTS_START: "GET_ALL_UPDATED_REPORTS_START",
  GET_ALL_UPDATED_REPORTS_SUCCESS: "GET_ALL_UPDATED_REPORTS_SUCCESS",
  GET_ALL_UPDATED_REPORTS_FAILED: "GET_ALL_UPDATED_REPORTS_FAILED",
  VIEW_UPDATED_REPORT_START: "VIEW_UPDATED_REPORT_START",
  VIEW_UPDATED_REPORT_SUCCESS: "VIEW_UPDATED_REPORT_SUCCESS",
  VIEW_UPDATED_REPORT_FAILED: "VIEW_UPDATED_REPORT_FAILED",
  GET_REPORT_COUNT_START: "GET_REPORT_COUNT_START",
  GET_REPORT_COUNT_SUCCESS: "GET_REPORT_COUNT_SUCCESS",
  GET_REPORT_COUNT_FAILED: "GET_REPORT_COUNT_FAILED",
  FILTER_COUNT_START: "FILTER_COUNT_START",
  FILTER_COUNT_SUCCESS: "FILTER_COUNT_SUCCESS",
  FILTER_COUNT_FAILED: "FILTER_COUNT_FAILED"
};

export default reportingDashboardConstants;
